import styled from 'styled-components';

export const HourWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Hour = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProductListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ErrorAndLoaderWrapper = styled.div`
  width: 100%;
  padding: 28px;
  display: flex;
  justify-content: center;
`;
